const TASK_TYPES = {
    CREATE_TASK: "CREATE_TASK",
    CREATE_TASK_LOADING: "CREATE_TASK_LOADING",
    CREATE_TASK_SUCCESS: "CREATE_TASK_SUCCESS",
    CREATE_TASK_ERROR: "CREATE_TASK_ERROR",
    CREATE_TASK_RESET: "CREATE_TASK_RESET",

    UPDATE_TASK: "UPDATE_TASK",
    UPDATE_TASK_LOADING: "UPDATE_TASK_LOADING",
    UPDATE_TASK_SUCCESS: "UPDATE_TASK_SUCCESS",
    UPDATE_TASK_ERROR: "UPDATE_TASK_ERROR",
    UPDATE_TASK_RESET: "UPDATE_TASK_RESET",

    CREATE_SUBTASK: "CREATE_SUBTASK",
    CREATE_SUBTASK_LOADING: "CREATE_SUBTASK_LOADING",
    CREATE_SUBTASK_SUCCESS: "CREATE_SUBTASK_SUCCESS",
    CREATE_SUBTASK_ERROR: "CREATE_SUBTASK_ERROR",
    CREATE_SUBTASK_RESET: "CREATE_SUBTASK_RESET",

    GET_SINGLE_SPRINT_TASK: "GET_SINGLE_SPRINT_TASK",
    GET_SINGLE_SPRINT_TASK_LOADING: "GET_SINGLE_SPRINT_TASK_LOADING",
    GET_SINGLE_SPRINT_TASK_SUCCESS: "GET_SINGLE_SPRINT_TASK_SUCCESS",
    GET_SINGLE_SPRINT_TASK_ERROR: "GET_SINGLE_SPRINT_TASK_ERROR",
    GET_SINGLE_SPRINT_TASK_RESET: "GET_SINGLE_SPRINT_TASK_RESET",

    GET_ALL_TASK: "GET_ALL_TASK",
    GET_ALL_TASK_LOADING: "GET_ALL_TASK_LOADING",
    GET_ALL_TASK_SUCCESS: "GET_ALL_TASK_SUCCESS",
    GET_ALL_TASK_ERROR: "GET_ALL_TASK_ERROR",
    GET_ALL_TASK_RESET: "GET_ALL_TASK_RESET",

    DELETE_TASK: "DELETE_TASK",
    DELETE_TASK_LOADING: "DELETE_TASK_LOADING",
    DELETE_TASK_SUCCESS: "DELETE_TASK_SUCCESS",
    DELETE_TASK_ERROR: "DELETE_TASK_ERROR",
    DELETE_TASK_RESET: "DELETE_TASK_RESET",


    UPDATE_TASK_STATUS: "UPDATE_TASK_STATUS",
    UPDATE_TASK_STATU_LOADING: "UPDATE_TASK_STATU_LOADING",
    UPDATE_TASK_STATU_SUCCESS: "UPDATE_TASK_STATU_SUCCESS",
    UPDATE_TASK_STATU_ERROR: "UPDATE_TASK_STATU_ERROR",
    UPDATE_TASK_STATU_RESET: "UPDATE_TASK_STATU_RESET",

    TASK_STATUS: "TASK_STATUS",
    TASK_STATUS_LOADING: "TASK_STATUS_LOADING",
    TASK_STATUS_SUCCESS: "TASK_STATUS_SUCCESS",
    TASK_STATUS_ERROR: "TASK_STATUS_ERROR",
    TASK_STATUS_RESET: "TASK_STATUS_RESET",


    GET_TASK_SUMMARY: "GET_TASK_SUMMARY",
    GET_TASK_SUMMARY_LOADING: "GET_TASK_SUMMARY_LOADING",
    GET_TASK_SUMMARY_SUCCESS: "GET_TASK_SUMMARY_SUCCESS",
    GET_TASK_SUMMARY_ERROR: "GET_TASK_SUMMARY_ERROR",
    GET_TASK_SUMMARY_RESET: "GET_TASK_SUMMARY_RESET",

    ADD_COMMENT: " ADD_COMMENT",
    ADD_COMMENT_LOADING: "ADD_COMMENT_LOADING",
    ADD_COMMENT_SUCCESS: "ADD_COMMENT_SUCCESS",
    ADD_COMMENT_ERROR: "ADD_COMMENT_ERROR",
    ADD_COMMENT_RESET: "ADD_COMMENT_RESET",


    GET_COMMENT: "GET_GET_COMMENT",
    GET_COMMENT_LOADING: "GET_COMMENT_LOADING",
    GET_COMMENT_SUCCESS: "GET_COMMENT_SUCCESS",
    GET_COMMENT_ERROR: "GET_COMMENT_ERROR",
    GET_COMMENT_RESET: "GET_COMMENT_RESET",

    DELETE_COMMENT: "DELETE_COMMENT",
    DELETE_COMMENT_LOADING: "DELETE_COMMENT_LOADING",
    DELETE_COMMENT_SUCCESS: "DELETE_COMMENT_SUCCESS",
    DELETE_COMMENT_ERROR: "DELETE_COMMENT_ERROR",
    DELETE_COMMENT_RESET: "DELETE_COMMENT_RESET",


    UPDATE_COMMENT: "UPDATE_COMMENT",
    UPDATE_COMMENT_LOADING: "UPDATE_COMMENT_LOADING",
    UPDATE_COMMENT_SUCCESS: "UPDATE_COMMENT_SUCCESS",
    UPDATE_COMMENT_ERROR: "UPDATE_COMMENT_ERROR",
    UPDATE_COMMENT_RESET: "UPDATE_COMMENT_RESET",

    GET_ASSIGN_USER: "GET_ASSIGN_USER",
    GET_ASSIGN_USER_LOADING: "GET_ASSIGN_USER_LOADING",
    GET_ASSIGN_USER_SUCCESS: "GET_ASSIGN_USER_SUCCESS",
    GET_ASSIGN_USER_ERROR: "GET_ASSIGN_USER_ERROR",
    GET_ASSIGN_USER_RESET: "GET_ASSIGN_USER_RESET",



    GET_ALL_REPORTER: "GET_ALL_REPORTER",
    GET_ALL_REPORTER_LOADING: "GET_ALL_REPORTER_LOADING",
    GET_ALL_REPORTER_SUCCESS: "GET_ALL_REPORTER_SUCCESS",
    GET_ALL_REPORTER_ERROR: "GET_ALL_REPORTER_ERROR",
    GET_ALL_REPORTER_RESET: "GET_ALL_REPORTER_RESET",


    GET_HISTORY: "GET_HISTORY",
    GET_HISTORY_LOADING: "GET_HISTORY_LOADING",
    GET_HISTORY_SUCCESS: "GET_HISTORY_SUCCESS",
    GET_HISTORY_ERROR: "GET_HISTORY_ERROR",
    GET_HISTORY_RESET: "GET_HISTORY_RESET",



    GET_BUGS: "GET_BUGS",
    GET_BUGS_LOADING: "GET_BUGS_LOADING",
    GET_BUGS_SUCCESS: "GET_BUGS_SUCCESS",
    GET_BUGS_ERROR: "GET_BUGS_ERROR",
    GET_BUGS_RESET: "GET_BUGS_RESET",




    GET_SUBTASK: "GET_SUBTASK",
    GET_SUBTASK_LOADING: "GET_SUBTASK_LOADING",
    GET_SUBTASK_SUCCESS: "GET_SUBTASK_SUCCESS",
    GET_SUBTASK_ERROR: "GET_SUBTASK_ERROR",
    GET_SUBTASK_RESET: "GET_SUBTASK_RESET",

    GET_PROJECT_FOR_TASKS: "GET_PROJECT_FOR_TASKS",
    GET_PROJECT_FOR_TASKS_LOADING: "GET_PROJECT_FOR_TASKS_LOADING",
    GET_PROJECT_FOR_TASKS_SUCCESS: "GET_PROJECT_FOR_TASKS_SUCCESS",
    GET_PROJECT_FOR_TASKS_RESET: "GET_PROJECT_FOR_TASKS_RESET",
    GET_PROJECT_FOR_TASKS_ERROR: "GET_PROJECT_FOR_TASKS_ERROR",
}

export default TASK_TYPES